<template>
    <div>
        <label>{{resource('IOFormat_Entities_DisplayName')}} *</label>
        <div>
            <multi-select name="SelectedAttributes" v-model="selectedEntities" :options="entities" label="text" />
            <error-message message="Please select at least one entity." v-if="showEntitiesError" />
        </div>

        <label>{{resource('IOFormat_Attributes_DisplayName')}} *</label>
        <div>
            <attribute v-for="attribute in selectedAttributes"
                :key="attribute.id"
                :value="attribute"
                :name.sync="attribute.name"
                :type.sync="attribute.type"
                :attributes="availableAttributes"
                       
                ref="attributes"

                @input="setSelectedAttribute($event)"
                @delete="deleteSelectedAttribute($event)"
            />
            <error-message message="Please select at least one attribute." v-if="showAttributesError" />
        </div>

        <div>
            <button class="btn btn-outline-secondary" @click="addSelectedAttribute" :disabled="availableAttributes.length === 0">
                <i class="fas fa-plus"></i> {{resource('Button_Add')}}
            </button>
        </div>

    </div>
</template>

<script>

import api from '../../../api';
import guid from '../../../../../Util/Mixins/guid';

import Attribute from './Attribute.vue';
import ErrorMessage from '../../../../../Components/Errors/ErrorMessage.vue';
import RequiredError from '../../../../../Components/Errors/RequiredErrorMessage.vue';
import MultiSelect from '../../../../../Components/Inputs/MultiSelect.vue';
import resources from '../../../../../Util/Mixins/resources';
import { bootstrapDangerGrowl } from '../../../../../Util/growler';

import { validationMixin  } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'entity-format',
    mixins: [guid, resources, validationMixin],
    components: {
        MultiSelect,
        Attribute,
        ErrorMessage,
        RequiredError
    },
    created() {
        api.getEntities().then((entities) => {
            this.entities = entities
        }, bootstrapDangerGrowl);
    },
    methods: {
        addSelectedAttribute() {
            const vm = this;
            const id = vm.guid();

            vm.selectedAttributes.push({
                id: id,
                entityId: vm.availableAttributes[0].entityId,
                label: vm.availableAttributes[0].label,
                value: vm.availableAttributes[0].value
            });
        },
        setSelectedAttribute(attribute) {
            const target = this.selectedAttributes.find((a) => a.id === attribute.id);
            target.entityId = attribute.entityId;
            target.label = attribute.label;
            target.value = attribute.value;
        },
        deleteSelectedAttribute(id) {
            const target = this.selectedAttributes.find((a) => a.id === id);
            const index = this.selectedAttributes.indexOf(target);

            this.selectedAttributes.splice(index, 1);
        },
        deleteSelectedAttributesByEntityId(entityId) {
            this.selectedAttributes = this.selectedAttributes.filter((attribute) => {
                return attribute.entityId !== entityId;
            });
        },
        validateAttributeRefs(){
            //Default to true, becomes false when encountering the first invalid ref
            this.selectedAttributeRefsValid = (this.$refs['attributes'] || []).reduce(
                (valid, ref) => valid && !ref.$v.$invalid,
                true
            );
        }
    },
    computed: {
        availableAttributes() {
            return this.attributes.filter((attribute) => {
                
                const selected = this.selectedAttributes.find((attr) => {
                    return attr.value === attribute.value;
                });

                return !selected && this.selectedEntities.indexOf(attribute.entityId) !== -1;
            })
        },
        showAttributesError() {
            return !this.attributesValid;
        },
        showEntitiesError() {
            return !this.entitiesValid;
        },
        attributesValid() {
            return this.$v.selectedAttributes.required;
        },
        entitiesValid() {
            return this.$v.selectedEntities.required;
        },
        valid() {
            return this.entitiesValid && this.attributesValid && this.selectedAttributeRefsValid;
        }
    },
    watch: {
        selectedEntities: {
            handler (newValue, oldValue) {
                const vm = this;

                //If entity has been removed
                if(newValue.length < oldValue.length) {
                    const id = oldValue.find((attribute) => newValue.indexOf(attribute) === -1);

                    vm.deleteSelectedAttributesByEntityId(id)
                    vm.attributes = vm.attributes.filter((attribute) => attribute.entityId !== id);

                } else {
                    const id = newValue.find((entityId) => oldValue.indexOf(entityId) === -1);
                    const entityName = this.entities.find((e) => e.value === id).text;

                    api.getAttributes(id,entityName).then((attributes) => {
                            vm.attributes = [...attributes, ...vm.attributes];
                        }, bootstrapDangerGrowl
                    );
                }
            },
            deep: true
        },
        selectedAttributes: {
            handler(value) {
                this.$emit('input', value.map((attribute) => {
                    return {
                        externalName: attribute.name || null,
                        internalTableId: attribute.entityId,
                        internalAttributeId: attribute.value,
                        itemType: attribute.type ? attribute.type.value : null
                    }
                }));
                
                this.$nextTick(() => {
                    this.validateAttributeRefs();
                })
            },
            deep: true
        },
        valid(value) {
            this.$emit('valid', value);
        }
    },
    validations: {
        selectedAttributes: {
            required
        },
        selectedEntities: {
            required
        }
    },
    data() {
        return {
            entities: [],
            selectedEntities: [],
            attributes: [],
            selectedAttributes: [],
            
            selectedAttributeRefsValid: true
        }
    },
    props: {
        value: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped src="../../../Style/create.scss">

</style>